export const PART_MAX_SIZE = 5000;
export const TOTAL_PARTS_MAX_SIZE = 10000;
export const MAX_PARTS = 50;
export const QUEUE_MAX_ADDITIONAL_ATTEMPTS = 2;
